import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import "@/App.css";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Process from "@/sections/Process";
import Interlude from "@/sections/Interlude";
import Miradas from "@/sections/Miradas";
import Skills from "@/sections/Skills";
import About from "@/sections/About";
import CvTeaser from "@/sections/CvTeaser";
import Femdacia from "@/sections/Femdacia";
import Coesgran from "@/sections/Coesgran";
import Frutas from "@/sections/Frutas";
import Closing from "@/sections/Closing";
import Marquee from "@/components/Marquee";
import MiraCursor from "@/components/MiraCursor";

function App() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 90, damping: 24 });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-mirian-cream font-sans text-mirian-wine antialiased">
      <motion.div
        className="fixed inset-x-0 top-0 z-50 h-[3px] origin-left bg-mirian-wine/70"
        style={{ scaleX: progress }}
      />
      <MiraCursor />
      <Nav />
      <main>
        <Hero />
        <Process />
        <Interlude />
        <Marquee />
        <Miradas />
        <Skills />
        <About />
        <CvTeaser />
        <Coesgran />
        <Femdacia />
        <Frutas />
        <Closing />
      </main>
    </div>
  );
}

export default App;
